import map from 'lodash/map'
import get from 'lodash/get'
import toFinite from 'lodash/toFinite'
import findIndex from 'lodash/findIndex'
import size from 'lodash/size'

import { annuity } from '../../../../utils/financeCalculations'
import { hexToRGBA } from '../../../../utils/colorConversions'
import { appColors } from '../../../../globalStyles'

export const buildProjectionDatasets = (actualProjection, requiredProjection, colors, ageData, usePresentValue, inflation) => {
  const { retirementAge, currentAge } = ageData

  const actualDataset = constructDatasetForProjection(actualProjection, currentAge, inflation, usePresentValue)
  const requiredDataset = constructDatasetForProjection(requiredProjection, currentAge, inflation, usePresentValue)
  return [
    // actual data

    {
      label: 'Actual',
      data: actualDataset,

      fill: true,
      borderWidth: 0,
      tension: 0.1,
      backgroundColor: hexToRGBA(colors.secondaryOneColor, 0.3),
      borderColor: hexToRGBA(colors.secondaryOneColor, 0.3),
      pointRadius: 0,
      pointHoverRadius: 0,
      pointBackgroundColor: appColors.system,
      pointBorderColor: appColors.white,
      pointBorderWidth: 2,
      pointHoverBorderWidth: 2,

      // Metadata for each dataset
      tickIndexes: [
        0,
        findIndex(actualProjection, { assets: 0 }),
        findIndex(actualProjection, { age: retirementAge }),
        size(actualProjection) - 1],
      retirementAge: retirementAge,
      projectionType: 'capital',
      tickType: 'age',
    },
  ]
}

const constructDatasetForProjection = (projection, currentAge, inflation, usePresentValue) => {
  return map(projection, (dataPoint) => ({
    // Metadata for each point
    capital: {
      future: get(dataPoint, 'assets'),
      present: annuity(get(dataPoint, 'assets'), currentAge - toFinite(get(dataPoint, 'age')), inflation)
    },
    income: {
      future: get(dataPoint, 'net_monthly_income'),
      present: annuity(get(dataPoint, 'net_monthly_income'), currentAge - toFinite(get(dataPoint, 'age')), inflation)
    },
    age: get(dataPoint, 'age'),

    // The x value for the line chart is required to be
    // a string.
    y: usePresentValue
      ? annuity(get(dataPoint, 'assets'), currentAge - toFinite(get(dataPoint, 'age')), inflation)
      : get(dataPoint, 'assets'),
    // NOTE: Whether labels can change dynamically has not been tested.
    x: `${get(dataPoint, 'age')} yrs`
  }))
}
